import React from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';

import PrismCol from '../GridElements/PrismCol';

import CELL_PROP_TYPES from '../constants';

class ChipCell extends React.PureComponent {
    static propTypes = {
        ...CELL_PROP_TYPES,
        value: PropTypes.arrayOf(PropTypes.shape({
            text: PropTypes.string,
            title: PropTypes.string
        }))
    };

    static defaultProps = {
        value: []
    };

    render() {
        const {
            value,
            className
        } = this.props;

        const columnClassName = classNames(
            'prism-grid__body-column',
            'prism-grid__body-column_list',
            className
        );

        return (
            <PrismCol
                {...this.props}
                className={columnClassName}
            >
                <div className="prism-grid__body-column_list-container">
                    {value.map(({ text, title }, index) => (
                        <span
                            key={`list-item_${index}`}
                            className="prism-grid__body-column_list-item"
                            title={title}
                        >
                            {text}
                        </span>
                    ))}
                </div>
            </PrismCol>
        )
    }
}

export default ChipCell;
